import { render, staticRenderFns } from "./FormStepMessage.vue?vue&type=template&id=17620e92&"
import script from "./FormStepMessage.vue?vue&type=script&lang=js&"
export * from "./FormStepMessage.vue?vue&type=script&lang=js&"
import style0 from "./FormStepMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports